import { useElementWidth } from '../../hooks/useElementWidth';
import { useRowStyles } from './Row.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Row = ({
  gap,
  justify,
  align,
  wrap,
  breakAt,
  children
}) => {
  const {
    ref,
    width
  } = useElementWidth(breakAt !== undefined);
  const isCollapsed = breakAt !== undefined && width !== null && width < breakAt;
  const style = useRowStyles({
    gap,
    justify,
    align,
    wrap,
    isCollapsed
  });
  return /*#__PURE__*/_jsx("div", {
    ref: ref,
    style: style,
    children: children
  });
};
export default Row;